import { connect } from 'react-redux';

import adminPaymentGateways from '_store/_actions/adminPaymentGateways';

import ChargeStatus from './ChargeStatus';

const mapStateToProps = state => {
  const { chargeStatus, isLoadingChargeStatus } = state.adminPaymentGateways;

  return {
    chargeStatus,
    isLoading: isLoadingChargeStatus,
  };
};

const mapDispatchToProps = {
  onFetchAdminChargeStatus: adminPaymentGateways.fetchAdminChargeStatus,
  onCreateAdminChargeStatus: adminPaymentGateways.createAdminChargeStatus,
  onUpdateAdminChargeStatus: adminPaymentGateways.updateAdminChargeStatus,
  onDeleteAdminChargeStatus: adminPaymentGateways.deleteAdminChargeStatus,
};

export default connect(mapStateToProps, mapDispatchToProps)(ChargeStatus);
